import { useState } from 'react';
import partnerService from '../services/partnerService';

const useStripeConnect = (partnerId, returnPath) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConnect = async () => {
    setLoading(true);
    setError(null);
    const newTab = window.open('', '_blank');
    try {
      const base = `${window.location.origin}${returnPath}`;
      const res = await partnerService.createStripeConnect(partnerId, {
        returnUrl: `${base}?stripe_return=1`,
        refreshUrl: `${base}?stripe_refresh=1`,
      });
      if (newTab) newTab.location.href = res.data.url;
      setLoading(false);
    } catch (err) {
      if (newTab) newTab.close();
      setError(err.response?.data?.error?.message || 'Failed to start Stripe onboarding');
      setLoading(false);
    }
  };

  return { handleConnect, loading, error };
};

export default useStripeConnect;
